module.exports = __webpack_public_path__ + "img/travessa_da_paixao.0c5d6932.jpg";